import LayoutRoute from '@platform-ui-common/components/LayoutRoute/index.js';
import { PartnerProgramsProvider } from '@platform-ui-common/hooks/contexts/PartnerPrograms';
import { ProgramRoute } from '@platform-ui-common/hooks/contexts/useProgram.js';
import ProgressProvider from '@platform-ui-common/hooks/useProgress/ProgressProvider.js';
import { TaxFormsProvider } from '@platform-ui-common/hooks/useTaxForms.js';
import useAuth from '@platform-ui/auth/hooks/useAuth/index.js';
import CaseDetails from '@platform-ui/case/pages/CaseDetails/index.js';
import FulfillmentDetails from '@platform-ui/case/pages/FulfillmentDetails/index.js';
import ClaimRoutes from '@platform-ui/claim/Routes.js';
import BaseRoutes, { UnauthenticatedRedirect } from '@platform-ui/utilities/Routes.js';
import { Redirect, Route, Switch } from 'react-router';
import ApplicationRoutes from './ApplicationRoutes.js';
import IntroRoutes from './IntroRoutes.js';
import { ApplicantLayout } from './components/index.js';
import { UserApplicationsProvider } from './hooks/useUserApplications.js';
import ProcessAndSubmit from './pages/ProcessAndSubmit/index.js';
import Profile from './pages/Profile/index.js';
import { ApplicationPortal } from './pages/index.js';
import ApplicantRoutes from './utils/ApplicantRoutes.js';

export default function Routes(): JSX.Element {
  const { loading, user } = useAuth();
  const unauthenticated = !loading && ((!user?.gcip && !user?.core) || !!user?.core?.admin);
  if (unauthenticated) return <UnauthenticatedRedirect />;
  return (
    <PartnerProgramsProvider>
      <TaxFormsProvider>
        <UserApplicationsProvider>
          <Switch>
            <LayoutRoute
              layout={ApplicantLayout}
              path={ApplicantRoutes.PROFILE}
              component={Profile}
            />
            <LayoutRoute
              layout={ApplicantLayout}
              path={ApplicantRoutes.CASE_DETAILS}
              component={CaseDetails}
            />
            <LayoutRoute
              layout={ApplicantLayout}
              path={ApplicantRoutes.FULFILLMENT_DETAILS}
              component={FulfillmentDetails}
            />
            <LayoutRoute
              layout={ApplicantLayout}
              path={ApplicantRoutes.APPLICATION_PORTAL}
              component={ApplicationPortal}
            />
            <LayoutRoute
              layout={ApplicantLayout}
              path={ApplicantRoutes.PROCESS_AND_SUBMIT}
              component={ProcessAndSubmit}
            />
            <ProgramRoute path={ApplicantRoutes.PROGRAM_INTRO} component={IntroRoutes} />
            <Route path={ApplicantRoutes.APPLICATION}>
              <ProgressProvider>
                <ApplicationRoutes />
              </ProgressProvider>
            </Route>
            <Route path={BaseRoutes.CLAIM}>
              <ProgressProvider>
                <ClaimRoutes />
              </ProgressProvider>
            </Route>
            <Redirect to={ApplicantRoutes.APPLICATION_PORTAL} />
          </Switch>
        </UserApplicationsProvider>
      </TaxFormsProvider>
    </PartnerProgramsProvider>
  );
}
